/* National Shielding: consent-aware attribution + native contact email fields. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.start(root);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var TTL = 90 * 86400000;
  var KEY = 'ns.attribution.v1';
  var PENDING = 'ns.contact.pending.v1';
  var fields = ['source','medium','campaign','term','content','campaign_id','gclid','gbraid','wbraid','msclkid','fbclid','referrer','page','at'];
  function clean(value) { return String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 200); }
  function host(value) { try { return new URL(value).hostname.toLowerCase(); } catch (_) { return ''; } }
  function sameSite(a,b) {
    var canonical = function (v) { return v.replace(/^www\./,''); };
    return canonical(a) === canonical(b);
  }
  function touch(url, referrer, now) {
    var u = new URL(url), p = u.searchParams, ref = host(referrer);
    var internal = ref && sameSite(ref,u.hostname);
    var t = {source:'direct',medium:'none',kind:'direct',page:u.pathname.slice(0,300),referrer:internal?'':ref,at:now};
    ['gclid','gbraid','wbraid','msclkid','fbclid'].forEach(function(k) { t[k]=clean(p.get(k)); });
    t.campaign=clean(p.get('utm_campaign')); t.term=clean(p.get('utm_term'));
    t.content=clean(p.get('utm_content')); t.campaign_id=clean(p.get('utm_id'));
    if (p.get('utm_source') || p.get('utm_medium') || t.campaign || t.campaign_id) {
      t.source=clean(p.get('utm_source')) || 'unspecified';
      t.medium=clean(p.get('utm_medium')) || 'unspecified'; t.kind='campaign';
    } else if (t.gclid || t.gbraid || t.wbraid || t.msclkid) {
      t.source=t.msclkid?'bing':'google'; t.medium='cpc'; t.kind='campaign';
    } else if (ref && !internal) {
      t.source=ref; t.medium='referral'; t.kind='referral';
      if (/^(www\.)?google\.[a-z.]+$/.test(ref)) { t.source='google'; t.medium='organic'; }
      else if (/(^|\.)bing\.com$/.test(ref)) { t.source='bing'; t.medium='organic'; }
      else if (/(^|\.)duckduckgo\.com$/.test(ref)) { t.source='duckduckgo'; t.medium='organic'; }
      else if (/(^|\.)search\.yahoo\.com$/.test(ref)) { t.source='yahoo'; t.medium='organic'; }
      else if (/(^|\.)(chatgpt\.com|chat\.openai\.com)$/.test(ref)) t.source='chatgpt';
      else if (ref==='gemini.google.com') t.source='gemini';
      else if (/(^|\.)perplexity\.ai$/.test(ref)) t.source='perplexity';
    } else if (internal) t.kind='internal';
    return t;
  }
  function validTouch(t) {
    return t && typeof t.source==='string' && typeof t.medium==='string' && typeof t.page==='string' && Number.isFinite(t.at);
  }
  function valid(s,now) {
    return s && s.version===1 && validTouch(s.first) && validTouch(s.latest) && now>=s.first.at && now-s.first.at<TTL;
  }
  function parse(raw,now) { try { var s=JSON.parse(raw); return valid(s,now)?s:null; } catch (_) { return null; } }
  function update(state,t,now) {
    if (!valid(state,now)) return {version:1,first:t,latest:t};
    return {version:1,first:state.first,latest:t.kind==='direct'||t.kind==='internal'?state.latest:t};
  }
  function allowed(privacy,method) { try { return !!privacy && privacy[method]()===true; } catch (_) { return false; } }
  function consume(pending,success,now) {
    if (!success || !pending || typeof pending.id!=='string' || !Number.isFinite(pending.at) || now<pending.at || now-pending.at>30*60000) return null;
    return pending;
  }
  function start(w) {
    if (w.NSAttributionLoaded) return;
    w.NSAttributionLoaded=true;
    var d=w.document, initial=touch(w.location.href,d.referrer,Date.now()), state=null;
    function privacy() { return w.Shopify && w.Shopify.customerPrivacy; }
    function storage(which,action,key,value) {
      try { return w[which][action](key,value); } catch (_) { return null; }
    }
    function refresh() {
      // A deferred Shopify API is unknown, not a withdrawal of existing consent.
      if (!privacy()) { state=null; return; }
      if (allowed(privacy(),'marketingAllowed')) {
        state=update(parse(storage('localStorage','getItem',KEY),Date.now()),initial,Date.now());
        storage('localStorage','setItem',KEY,JSON.stringify(state));
      } else {
        state=null; storage('localStorage','removeItem',KEY);
      }
      if (!allowed(privacy(),'analyticsProcessingAllowed')) storage('sessionStorage','removeItem',PENDING);
    }
    function id() {
      try { return w.crypto.randomUUID(); } catch (_) { return 'ns-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,12); }
    }
    function set(form,label,value) {
      var name='contact['+label+']';
      var input=Array.prototype.find.call(form.elements,function(el) { return el.name===name; });
      if (!input) { input=d.createElement('input'); input.type='hidden'; input.name=name; form.appendChild(input); }
      input.value=String(value==null?'':value);
    }
    function attach(form) {
      if (form.dataset.nsBound) return;
      form.dataset.nsBound='true';
      form.addEventListener('submit',function () {
        refresh();
        var submissionId=id();
        set(form,'Submission ID',submissionId);
        set(form,'Submitted at UTC',new Date().toISOString());
        set(form,'Submission page',w.location.pathname);
        set(form,'Attribution status',state?'Available — first observed, up to 90 days':'Unavailable — marketing permission not granted or unavailable');
        // Remove previously populated values if permission was withdrawn between attempts.
        ['First observed','Latest non-direct'].forEach(function(prefix,index) {
          fields.forEach(function(k) {
            var t=state && (index===0?state.first:state.latest);
            var value=t && t[k];
            if (k==='at' && value) value=new Date(value).toISOString();
            set(form,prefix+' '+k,value || '');
          });
        });
        var preview=form.closest('[data-ns-preview="true"]') || (w.Shopify && (w.Shopify.designMode || w.Shopify.previewMode));
        if (!preview && allowed(privacy(),'analyticsProcessingAllowed')) {
          storage('sessionStorage','setItem',PENDING,JSON.stringify({id:submissionId,at:Date.now(),form:form.id,page:w.location.pathname}));
        }
      });
    }
    function confirm() {
      if (!privacy()) return;
      var success=d.querySelector('[data-ns-contact-success]');
      if (!success) return;
      var raw=storage('sessionStorage','getItem',PENDING), pending;
      try { pending=JSON.parse(raw); } catch (_) { pending=null; }
      var confirmed=consume(pending,true,Date.now());
      if (!confirmed || confirmed.form!==success.dataset.nsContactSuccess || confirmed.page!==w.location.pathname) return;
      // Consume before publishing: reload/back/duplicate script must not emit twice.
      storage('sessionStorage','removeItem',PENDING);
      if (storage('sessionStorage','getItem',PENDING)!==null) return;
      if (!allowed(privacy(),'analyticsProcessingAllowed') || success.closest('[data-ns-preview="true"]')) return;
      w.dataLayer=w.dataLayer||[];
      w.dataLayer.push({event:'conversion_thank_you',submission_id:confirmed.id,transaction_id:confirmed.id,form_id:'ns-contact'});
    }
    function bind() { d.querySelectorAll('form[data-ns-contact]').forEach(attach); }
    function ready() { refresh(); bind(); confirm(); }
    d.addEventListener('visitorConsentCollected',ready);
    d.addEventListener('shopify:section:load',bind);
    if (d.readyState==='loading') d.addEventListener('DOMContentLoaded',ready); else ready();
    if (w.Shopify && w.Shopify.loadFeatures) {
      w.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],function(error) { if (!error) ready(); });
    }
  }
  return {touch:touch,update:update,parse:parse,consume:consume,allowed:allowed,start:start};
});
